import { Component, ElementRef, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ApiService, AuthService, BoldBiService, SessionService } from '../../../services';
import { SfBiDashboard, User } from '../../../models';
import { timeout } from 'rxjs/operator/timeout';
import { MenuItemModel, SidebarComponent } from '@syncfusion/ej2-angular-navigations';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
import { EmailComposerComponent } from '../../common/email-composer/email-composer.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UscBiService } from '../../../services/usc-bi/usc-bi.service';
import { Observable, Subscription } from 'rxjs';
declare var BoldBI: any;

@Component({
    selector: 'sn-usc-dashboard',
    templateUrl: './usc-dashboard.component.html',
    styleUrls: ['./usc-dashboard.component.css'],
    // encapsulation: ViewEncapsulation.None
})
export class UscDashboardComponent implements OnInit {
    @ViewChild('sidebarMenuInstance') public sidebarMenuInstance: SidebarComponent;
    public type: string = 'Push';
    public target: string = '.main-content';
    public width: string = '210px';
    public dockSize: string = '50px';
    public enableDock: boolean = true;
    public closeOnDocumentClick: boolean = false;
    public isOpen: boolean = false;

    public update_date: string = 'Nov 26, 2021';
    public update_time: string = '10:27 am CST';
    public is_bi_portal_available: boolean = true;
    bi_portal_unavailable_message: string;
    userSub: Subscription;

    public activeUser: User;

    constructor(
        public ngbModal: NgbModal,
        public elementRef: ElementRef,
        public apiService: ApiService,
        public boldBiService: BoldBiService,
        public authService: AuthService,
        public sessionService: SessionService,
        public uscBiService: UscBiService
    ) {

    }

    ngAfterViewInit() {
        this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#161b26';
    }

    public userMenuItem: MenuItemModel = {
        text: 'Users ',
        iconCss: 'icon-user icon',
        items: [
            { text: 'Logout', id: 'logout' },
        ]
    };

    public emailMenuItem: MenuItemModel = {
        text: 'Options',
        iconCss: 'e-icons e-settings',
        items: [
            { text: 'Submit a Dashboard Inquiry', id: 'inquiry' },
        ]
    }

    public dashboardMenuItems: MenuItemModel[] = [];

    public getMenuItems(): MenuItemModel[] {
        let menu_items: MenuItemModel[] = this.dashboardMenuItems;
        menu_items.push(this.emailMenuItem);
        var user = this.authService.getAuth();
        this.userMenuItem.text = user.first_name + ' ' + user.last_name;
        menu_items.push(this.userMenuItem);
        return menu_items;
    }

    public getAccountMenuItems(): MenuItemModel[] {
        var user = this.authService.getAuth();
        this.userMenuItem.text = user.first_name + ' ' + user.last_name;
        let menu_items: MenuItemModel[] = [this.userMenuItem];
        return menu_items;
    }

    // public getSettingMenuItems(): MenuItemModel[] {
    //     let menu_items: MenuItemModel[] = [this.emailMenuItem ];
    //     return menu_items;
    // }

    // open new tab
    newTabClick(): void {
        let URL = location.href.replace(location.search, '');
        document.getElementById('newTab').setAttribute('href', URL.split('#')[0] + 'sidebar/sidebar-menu');
    }

    openClick() {
        // if (this.isOpen)
        //     this.sidebarMenuInstance.hide();
        // else 
        //     this.sidebarMenuInstance.show();
        this.sidebarMenuInstance.toggle();
    }

    ngOnDestroy() {
        if (this.userSub) this.userSub.unsubscribe();
    }

    ngOnInit() {
        this.userSub = this.authService.currentUser.subscribe(
            currentUser => {
                if (currentUser && currentUser.ID) {
                    this.is_bi_portal_available = this.uscBiService.isBiServiceAvailable();
                    if (this.is_bi_portal_available) {
                        this.loadDashboard();
                        this.sessionService.log("Email Templates Loading:", new Date());
                        this.uscBiService.loadEmailTemplates().subscribe(
                            data => {
                                this.sessionService.log("Email Templates Loaded", new Date())
                                this.sessionService.log(data);
                            },
                            err => { this.sessionService.log(err) }
                        )
                    } else {
                        this.bi_portal_unavailable_message = 'Due to an unexpected surge in traffic, the dashboard is temporarily unavailable.  Please try again in five minutes.  We appreciate your patience.';
                    }
                }
            })
    }

    public menuSelect(event) {
        var dashboard = this.dashboards.find(db => db.Id == event.item.properties.id);
        if (dashboard != null) this.renderDashboard(dashboard);
        else if (event.item.properties.id == "inquiry") this.showEmailComposer()
        else if (event.item.properties.id == "logout") this.authService.logoff();
    }

    created_dashboard: any;
    dashboards: any[];
    current_dashboard: any;
    dashboard_configs: any;
    searchText: string;

    loadDashboard() {
        var params = { "searchText": this.searchText };
        this.apiService.loadSfBiDashboards(params).subscribe(
            (result) => {
                this.dashboards = JSON.parse(result.dashboards);
                this.dashboard_configs = result.configs;
                this.update_date = result.bi_last_sales_extract.update_date;
                this.update_time = result.bi_last_sales_extract.update_time;
                this.dashboardMenuItems = this.generateDashboardMenuItems(this.dashboards);
                var dashboard = this.dashboards.find(db => db.Id == this.dashboardMenuItems[0].items[0].id);
                this.renderDashboard(dashboard);
            },
            (reason) => { this.sessionService.log('loadSfBiDashboards failed'); }
        );
    }

    generateDashboardMenuItems(dashboards: any[]): MenuItemModel[] {
        let menuItems: MenuItemModel[] = [];
        var ordered_configs = [];
        for (const db_id in this.dashboard_configs) {
            ordered_configs.push(this.dashboard_configs[db_id]);
        }

        ordered_configs.sort(function (a, b) {
            return a.order - b.order;
        })

        console.log(ordered_configs);

        ordered_configs.forEach(config => {
            //dashboards.forEach(db => {
            //var config = this.dashboard_configs[db.Id];
            var db = this.dashboards.find(d => d.Id == config.Id);
            if (db) {
                var mi_category = menuItems.find(mi => mi.text == config.display_category);
                // text: 'Dashboard Category',
                // iconCss: 'icon-user icon',
                // items: [
                //     { text: 'Dashboard Name' },
                // ]        
                if (mi_category == null) {
                    mi_category = {
                        text: config.display_category,
                        iconCss: config.category_icon + ' icon',
                        items: [],
                    }
                    menuItems.push(mi_category);
                }
                mi_category.items.push({ text: config.display_name, id: db.Id });
            }
        });
        return menuItems;
    }

    renderDashboard(dashboard: SfBiDashboard) {
        if (dashboard != null) {
            this.current_dashboard = dashboard;
            var config = this.dashboard_configs[dashboard.Id];
            var filterParameters = "";
            // var filterParameters = "Region=" + encodeURIComponent('Michael Adams');
            //  filterParameters += "?Area=" + encodeURIComponent('William Gott');
            if (config && config.dashboard_filters) {
                config.dashboard_filters.forEach(f => {
                    if (f.value) filterParameters += f.parameter + "=" + encodeURIComponent(f.value) + "&";
                    // "Area=" + encodeURIComponent('William Gott');
                });
            }
            this.apiService.getAuthToken().subscribe(result => {
                this.created_dashboard = this.boldBiService.create(BoldBI, result.token, dashboard.Id, "dashboard", filterParameters);
                console.log(this.created_dashboard);
                this.created_dashboard.loadDashboard();
            });
        } else {
            console.log("renderDashboard error");
        }
    }

    showEmailComposer() {
        this.activeUser = this.authService.getActive();
        const modalRef = this.ngbModal.open(EmailComposerComponent, { size: "lg", backdrop: 'static', keyboard: false });
        modalRef.componentInstance.emailTemplates = [this.uscBiService.getEmailTemplatesByName("USC: Dashboard Inquiry")];
        modalRef.componentInstance.view_item_type = 'UR';
        modalRef.componentInstance.view_item_ID = this.activeUser.ID;
        modalRef.componentInstance.composer_settings = { is_subject_readonly: false }
        modalRef.componentInstance.isSubjectEditable = true;
        // modalRef.result.then((result) => {
        // }, (reason) => {
        // });    
    }

    preprocessEmailTemplate(selectedTemplateID, view_item_type, view_ID): Observable<any> {
        return new Observable(observer => {
            observer.next(this.getEmailTemplatesByID(selectedTemplateID, view_item_type, view_ID));
            observer.complete();
        });
    }

    getEmailTemplatesByID(selectedTemplateID, view_item_type, view_ID) {
        return this.uscBiService.getEmailTemplatesByID(selectedTemplateID);
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-bi/usc-dashboard/usc-dashboard.component.ts